//* 组件库
import type { UiTableOption2 } from "various-ui";

//* 样式
import css from "../style/index.module.less";

export const useOptions = () => {
    //* 插件
    const i18n = useI18n();

    return {
        disease: <UiTableOption2[]>[
            { key: "number", name: "#", align: "center" },
            { key: "name", name: i18n.t("Disease"), align: "singularity" },
            { key: "organ", name: i18n.t("AnatomicalCategory"), align: "singularity" },
            { key: "source", name: i18n.t("Score"), sort: true, align: "center" },
            { key: "mutation_number", name: i18n.t("MutationCount", 2), sort: true, align: "center" },
        ],

        gene: <UiTableOption2[]>[
            { key: "number", name: "#", align: "center" },
            { key: "name", name: i18n.t("Gene"), align: "center" },
            { "key": "function", "name": i18n.t("Function"), "align": "center", "extra": true, "extra-name": css.checkboxs },
            { key: "source", name: i18n.t("Score"), sort: true, align: "center" },
            { key: "mutation_number", name: i18n.t("MutationCount", 2), sort: true, align: "center" },
        ],
    };
};
